module.exports = __webpack_public_path__ + "img/switzerland-genitourinary-diseases-female.b7f10f57.png";